import React, { useEffect } from "react";
import { Grid, Link } from "@mui/material";
import Card from "@mui/material/Card";
import SingleUtility from "../allUtilities/SingleUtility";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@mui/styles";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectPaymentsState } from "../../../../../features/payments/paymentsSlice";
import { setGeneralMessage } from "../../../../../features/global/globalDataSlice";
import { texts } from "../../../../general/texts";
import FinishRegistration from "../../../../registration/registrationSteps/FinishRegistration";
import { selectDigitalbState } from "../../../../../features/digitalb/digitalbSlice";
import { selectUserInfo } from "../../../../../features/userInfo/userInfoSlice";

const Utilities = (props) => {
  // const [utilities, setUtilities] = React.useState([])
  const navigate = useNavigate();
  const location = useLocation();
  const paymentsSliceState = useSelector(selectPaymentsState);
  const digitalbSliceState = useSelector(selectDigitalbState);
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const utilities = props?.utilities;

  const useStyles = makeStyles({
    card: {
      borderRadius: "20px",
      width: "58%",
      minHeight: "72vh",
      boxShadow: "0 0 15px 5px #E5E7EA",
      "@media (max-width: 1200px )": { width: "80%" },
    },
  });

  const classes = useStyles();

  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  const determineOnClick = (status, utility) => {
    if (status === 0) {
      navigate(utility);
    } else {
      if (userInfo.accountType === 3 ) {
        handleOpen();
      }
      else {
        dispatch(
          setGeneralMessage({
            type: "error",
            message: texts["message-locked-service"], 
          })
        );
      }
    }
  };

  return (
    <Grid container item md={12} xs={12} justifyContent="center" pt={5}>
      <Card className={classes.card}>
        <Grid
          container
          item
          md={2.5}
          sm={3}
          xs={2}
          mt={5}
          justifyContent={"center"}
        >
          <Link
            component={"button"}
            onClick={() => {
              location.pathname === "/onpayments"
                ? navigate("/dashboard")
                : navigate(-1);
            }}
          >
            <ArrowBackIosNewIcon color="warning" />
          </Link>
        </Grid>
        <Grid container item justifyContent={"center"}>
          {utilities?.length === 0 ? (
            Array.from(new Array(12)).map(
              (
                _,
                index 
              ) => (
                <Grid
                  container
                  item
                  md={3}
                  sm={4}
                  xs={12}
                  mt={7}
                  justifyContent={"center"}
                  key={index}
                >
                  {" "}
                  <Skeleton
                    variant="rect"
                    width={"100px"}
                    height={"100px"}
                    animation={"wave"}
                    style={{ borderRadius: "15px" }}
                  />
                </Grid>
              )
            )
          ) : (
            <Grid container item p={"3%"}>
              {utilities &&
                utilities.map((utility, index) => {
                  return (
                    <Grid container item md={3} sm={4} xs={12} key={index} visibility={utility.serviceName === 'DIGITALBOTT' &&  digitalbSliceState.isAlbania !== true ? "hidden" : ""} >
                      <SingleUtility
                        onClick={() =>
                          determineOnClick(utility.status, utility.serviceName)
                        }
                        publicName={utility.publicName}
                        serviceName={utility.serviceName}
                        image={utility.image}
                      />
                    </Grid>
                  );
                })}
            </Grid>
          )}
        </Grid>
      </Card>
      <FinishRegistration
        isDialogOpened={isOpen}
        handleCloseDialog={() => setIsOpen(false)}
      />
    </Grid>
  );
};
export default Utilities;
